import type { Followup, FollowupFilter } from './types'
import { apiRequest } from '../../shared/api/base'

function buildQuery(filter: FollowupFilter): string {
  switch (filter) {
    case 'open':
      return '?status=active'
    case 'due-soon':
      return '?status=active&dueSoon=true'
    case 'snoozed':
      return '?status=snoozed'
    case 'resolved':
      return '?status=resolved'
    case 'all':
    default:
      return ''
  }
}

export async function fetchFollowups(filter: FollowupFilter = 'all'): Promise<Followup[]> {
  const query = buildQuery(filter)
  const data = await apiRequest<{ followups: Followup[] }>(`/followups${query}`)
  return data.followups ?? []
}

export async function createLoop(data: { title: string; context?: string; dueAt?: string; groupName?: string }): Promise<Followup> {
  const result = await apiRequest<{ followup: Followup }>('/followups', {
    method: 'POST',
    body: JSON.stringify(data),
  })
  return result.followup
}

export async function resolveLoop(id: string): Promise<Followup> {
  const result = await apiRequest<{ followup: Followup }>(`/followups/${id}/resolve`, {
    method: 'PATCH',
  })
  return result.followup
}

export async function snoozeLoop(id: string, until: string): Promise<Followup> {
  const result = await apiRequest<{ followup: Followup }>(`/followups/${id}/snooze`, {
    method: 'PATCH',
    body: JSON.stringify({ until }),
  })
  return result.followup
}

export async function updateLoopDueAt(id: string, dueAt: string | null): Promise<Followup> {
  const result = await apiRequest<{ followup: Followup }>(`/followups/${id}`, {
    method: 'PATCH',
    body: JSON.stringify({ dueAt }),
  })
  return result.followup
}
